import React from 'react';
import { connect } from 'react-redux';
import { routes } from 'constants/config';
import * as actions from 'actions/shared/index/mass_actions.js';
import MassAction from './MassAction';

const MassOwnershipView = ({
  applyOwners,
  requestSharedOwners,
  resource,
  ownersRoute,
}) => (
  <MassAction
    requestShared={requestSharedOwners}
    applyChanges={applyOwners}
    title={t('mass_actions.mass_ownership.title')}
    placeholder={t('mass_actions.mass_ownership.add_owner')}
    noSharedResourceText={t('mass_actions.mass_ownership.no_shared_owner')}
    autocompleteUrl={ownersRoute}
    resource={resource}
  />
);

MassOwnershipView.defaultProps = {
  resource: 'owners',
  ownersRoute: routes.OWNERSHIPS_PEOPLE + '?ownership_type=shared_ownership',
};

const mapDispatchToProps = {
  requestSharedOwners: actions.requestSharedOwners,
  applyOwners: actions.applyOwners,
};

export default connect(null, mapDispatchToProps)(MassOwnershipView);
